/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import Select from 'react-select';
import { calculateAge } from "../utils/utils";
import { useNavigate, useParams } from 'react-router-dom';
import { cleanRut, formatRut } from "../utils/rut";

const IngresoAuxiliar = ({ idAuxiliar, onSuccess }) => {
    const params = useParams();
    const id = idAuxiliar || params.id;
    const [especialidades, setEspecialidades] = useState([]);
    const [turnos, setTurnos] = useState([]);
    const [selectedTurnos, setSelectedTurnos] = useState([]);
    const [categorizaciones, setCategorizaciones] = useState([]);
    const [clasificaciones, setClasificaciones] = useState([]);
    const [anticipoOptions, setAnticipoOptions] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [tipoDocumento, setTipoDocumento] = useState("RUT");

    const navigate = useNavigate();

    // NUEVO: Estado para Datos de Pago
    const [datosPago, setDatosPago] = useState({
        tipoCuenta: 'propia', // 'propia' o 'tercero'
        rutPago: '',
        nombrePago: '',
        banco: '',
        tipoCuentaBancaria: '',
        numeroCuenta: '',
        datosSII: ''
    });

    // NUEVO: manejadores para Datos de Pago
    const handleTipoCuentaChange = (e) => {
        const tipo = e.target.value;
        setDatosPago(prev => ({
            ...prev,
            tipoCuenta: tipo,
            rutPago: tipo === 'propia' ? datosPersonales.rut : '',
            nombrePago: tipo === 'propia'
                ? `${datosPersonales.nombre} ${datosPersonales.primerApellido}`.trim()
                : ''
        }));
    };

    const handleDatosPagoChange = (e) => {
        const { name, value } = e.target;
        setDatosPago(prev => ({ ...prev, [name]: value }));
    };

    const [datosPersonales, setDatosPersonales] = useState({
        id: "0",
        rut: "",
        tipoDocumento: "",
        nombre: "",
        segundoApellido: "",
        primerApellido: "",
        direccion: "",
        comuna: "",
        numeroCelular: "",
        estatura: "",
        nacionalidad: "",
        situacionMigratoria: "",
        fechaNacimiento: "",
        fechaIngreso: "",
        fechaRetiro: "",
        fechaReintegro: "",
        historialEstadoLaboral: [],
        presentacionPersonal: "",
        observacionesPersonales: "",
        curriculum: null,
        sexo: 1,
        mail: "",
    });

    const [datosProfesionales, setDatosProfesionales] = useState({
        categoria: 0,
        clasificaciones: 0,
        titulo: "",
        institucion: "",
        especialidades: [],
        experienciaDomicilio: "",
        experienciaGeriatrica: "",
        anticipo: "",
        evaluacion: "",
        recomendadaPor: "",
        obsTurnos: "",
        obsCategoria: ""
    });

    const [disponibilidadTurnos, setDisponibilidadTurnos] = useState({
        observacionesTurnos: "",
    });

    const extraerIdsEspecialidades = (especialidadesRaw) => {
        return especialidadesRaw.map((esp) => esp.especialidadID);
    };

    const extraerIdsTurnos = (turnosRaw) => {
        return turnosRaw.map((turno) => turno.turnoID);
    };

    const resetForm = () => {
        setDatosPersonales({
            id: "0",
            rut: "",
            tipoDocumento: "",
            nombre: "",
            segundoApellido: "",
            primerApellido: "",
            direccion: "",
            comuna: "",
            numeroCelular: "",
            estatura: "",
            nacionalidad: "",
            situacionMigratoria: "",
            fechaNacimiento: "",
            fechaIngreso: "",
            fechaRetiro: "",
            fechaReintegro: "",
            historialEstadoLaboral: [],
            presentacionPersonal: "",
            observacionesPersonales: "",
            curriculum: null,
            sexo: 1,
            mail: "",
        });

        setDatosProfesionales({
            categoria: 0,
            clasificacion: 0,
            titulo: "",
            institucion: "",
            especialidades: [],
            experienciaDomicilio: "",
            experienciaGeriatrica: "",
            anticipo: "",
            evaluacion: "",
            recomendadaPor: "",
            obsTurnos: "",
            obsCategoria: ""
        });

        setDatosPago({
            tipoCuenta: 'propia',
            rutPago: '',
            nombrePago: '',
            banco: '',
            tipoCuentaBancaria: '',
            numeroCuenta: '',
            datosSII: ''
        });

        setSelectedTurnos([]);
        setDisponibilidadTurnos({ observacionesTurnos: "" });
    };


    useEffect(() => {
        async function fetchData() {
            try {
                gdAlertify.showLoader()
                const response = await axiosInstance.get("/params/especialidades");
                const turnosResponse = await axiosInstance.get("/params/turnos");
                const categorizacionesResponse = await axiosInstance.get("/params/categorias");
                const clasificacionesResponse = await axiosInstance.get("/params/clasificaciones");
                const comunaResponse = await axiosInstance.get("/params/comunas");
                setTurnos(turnosResponse.data.turnos);
                setEspecialidades(response.data.especialidades);
                setCategorizaciones(categorizacionesResponse.data.categorias.map(categorias => ({
                    value: categorias.id,
                    label: categorias.codigo
                })));
                setClasificaciones(clasificacionesResponse.data.clasificaciones.map(clasificacion => ({
                    value: clasificacion.id,
                    label: clasificacion.nombre
                })));
                setComunas(comunaResponse.data.comunas.map(comuna => ({
                    value: comuna.id,
                    label: comuna.nombre
                })));
                setAnticipoOptions([
                    { value: 0, label: 'No' },
                    { value: 1, label: 'Si' }
                ]);

                if (id != undefined) {
                    const response = await axiosInstance.get("/auxiliar/busqueda", {
                        params: { idAuxiliar: id }
                    });
                    console.log(response);
                    if (!response.data.error) {
                        let auxiliarData = response.data.data[0];

                        // Buscar y setear la comuna seleccionada
                        const comunaSeleccionada = comunaResponse.data.comunas.find(com => com.id == auxiliarData.comunaID);
                        console.log(comunaSeleccionada)
                        if (comunaSeleccionada) {
                            handleComuna({ value: comunaSeleccionada.id, label: comunaSeleccionada.nombre });
                        }

                        // Buscar y setear la categoría seleccionada
                        const categoriaSeleccionada = categorizacionesResponse.data.categorias.find(cat => cat.id == auxiliarData.categoriaID);
                        console.log(categoriaSeleccionada)
                        if (categoriaSeleccionada) {
                            handleCategorizacion({ value: categoriaSeleccionada.id, label: categoriaSeleccionada.codigo });
                        }

                        // Buscar y setear la clasificación seleccionada
                        const clasificacionSeleccionada = clasificacionesResponse.data.clasificaciones.find(cl => cl.id == auxiliarData.clasificacionID);
                        console.log(clasificacionSeleccionada)
                        if (clasificacionSeleccionada) {
                            handleClasificacion({ value: clasificacionSeleccionada.id, label: clasificacionSeleccionada.nombre });
                        }

                        // Setear anticipo (0 o 1)
                        const anticipoSeleccionado = auxiliarData.anticipo === 1 ? { value: 1, label: 'Si' } : { value: 0, label: 'No' };
                        console.log(anticipoSeleccionado)
                        handleAnticipo(anticipoSeleccionado);
                        console.log('pintando todo');

                        setSelectedTurnos(extraerIdsTurnos(auxiliarData.turnos));

                        setDatosPersonales({
                            id: auxiliarData.id,
                            rut: auxiliarData.rut,
                            tipoDocumento: auxiliarData.tipoDocumento,
                            nombre: auxiliarData.nombre, // ya que `nombre` está vacío
                            segundoApellido: auxiliarData.apellidoMaterno,
                            primerApellido: auxiliarData.apellidoPaterno,
                            direccion: auxiliarData.direccion,
                            comuna: auxiliarData.comunaID,
                            numeroCelular: auxiliarData.celular,
                            estatura: auxiliarData.estatura,
                            nacionalidad: auxiliarData.nacionalidad,
                            situacionMigratoria: auxiliarData.situacionMigratoria || "",
                            hijosMenores: auxiliarData.hijosMenores18,
                            fechaNacimiento: auxiliarData.fechaNacimiento,
                            fechaIngreso: auxiliarData.fechaIngreso,
                            fechaRetiro: auxiliarData.fechaRetiro || "",
                            fechaReintegro: auxiliarData.fechaReintegro || "",
                            historialEstadoLaboral: auxiliarData.historialEstadoLaboral || [],
                            presentacionPersonal: auxiliarData.presentacionPersonal,
                            observacionesPersonales: auxiliarData.observaciones,
                            curriculum: auxiliarData.curriculum || "", // por si no viene
                            sexo: auxiliarData.sexo,
                            mail: auxiliarData.mail
                        });
                        setTipoDocumento(auxiliarData.tipoDocumento);
                        console.log(auxiliarData)

                        setDatosProfesionales({
                            categoria: auxiliarData.categoriaID,
                            clasificacion: auxiliarData.clasificacionID,
                            titulo: auxiliarData.titulo,
                            institucion: auxiliarData.institucion,
                            especialidades: extraerIdsEspecialidades(auxiliarData.especialidades),
                            experienciaDomicilio: auxiliarData.experienciaDomicilio || "", // si está disponible
                            experienciaGeriatica: auxiliarData.experienciaGeriatica || "", // igual
                            anticipo: auxiliarData.anticipo,
                            evaluacion: auxiliarData.evaluacion,
                            recomendadaPor: auxiliarData.recomendadaPor,
                            obsTurnos: auxiliarData.obsTurnos,
                            obsCategoria: auxiliarData.obs_categoria || ""
                        });

                        if (auxiliarData.datosPago != undefined && auxiliarData.datosPago != null) {
                            setDatosPago({
                                tipoCuenta: auxiliarData.datosPago.tipo_cuenta, // 'propia' o 'tercero'
                                rutPago: auxiliarData.datosPago.rut_pago,
                                nombrePago: auxiliarData.datosPago.nombre_pago,
                                banco: auxiliarData.datosPago.banco,
                                tipoCuentaBancaria: auxiliarData.datosPago.tipo_cuenta_bancaria,
                                numeroCuenta: auxiliarData.datosPago.numero_cuenta,
                                datosSII: auxiliarData.datosPago.datos_sii
                            })
                        }
                    }
                    gdAlertify.hideLoader()
                } else {
                    gdAlertify.hideLoader()
                }
            } catch (error) {
                gdAlertify.hideLoader()
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);


    const handleTurnoChange = (e) => {
        const value = parseInt(e.target.value); // Asegúrate de convertir a número
        const { checked } = e.target;

        setSelectedTurnos((prev) =>
            checked
                ? [...prev, value] // Si el checkbox está marcado, agrega el valor
                : prev.filter((id) => id !== value) // Si no está marcado, elimina el valor
        );
    };

    const validarRut = (rut) => {
        if (tipoDocumento === "RUT") {
            const rutLimpio = cleanRut(rut);
            return /^[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-[0-9kK]$/.test(rut);
        }
        return true;
    };

    // const handleInputChange = (e, section, setSection) => {
    //     var { name, value, type, checked } = e.target;

    //     if (name === "rut" && tipoDocumento === "RUT") {
    //         value = formatRut(cleanRut(value));
    //     }
    //     if (type === "checkbox") {
    //         setSection((prev) => ({
    //             ...prev,
    //             [name]: checked,
    //         }));
    //     } else {
    //         setSection((prev) => ({
    //             ...prev,
    //             [name]: value,
    //         }));
    //     }
    // };

    const handleInputChange = (e, section, setSection) => {
        let { name, value, type, checked } = e.target;
        if (name === "rut" && tipoDocumento === "RUT") {
            value = formatRut(cleanRut(value));
        }
        const newVal = type === 'checkbox' ? checked : value;
        setSection(prev => ({ ...prev, [name]: newVal }));

        if (setSection === setDatosPersonales && datosPago.tipoCuenta === 'propia') {
            if (name === 'rut') {
                setDatosPago(prev => ({ ...prev, rutPago: newVal }));
            } else if (name === 'nombre' || name === 'primerApellido') {
                const nombreAct = name === 'nombre' ? newVal : datosPersonales.nombre;
                const apeAct = name === 'primerApellido' ? newVal : datosPersonales.primerApellido;
                setDatosPago(prev => ({ ...prev, nombrePago: `${nombreAct} ${apeAct}`.trim() }));
            }
        }
    };


    const handleEspecialidadesChange = (e) => {
        const value = parseInt(e.target.value); // 👈 importante
        const { checked } = e.target;
        setDatosProfesionales((prev) => ({
            ...prev,
            especialidades: checked
                ? [...prev.especialidades, value]
                : prev.especialidades.filter((esp) => esp != value),
        }));
        console.log(datosProfesionales)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (tipoDocumento === "RUT" && !validarRut(datosPersonales.rut)) {
            gdAlertify.alert("El RUT ingresado no es válido");
            return;
        }

        if (datosPersonales.comuna == '') {
            gdAlertify.alert("Debe seleccionar una comuna");
            return;
        }

        if (datosProfesionales.categoria == '' || datosProfesionales.categoria == undefined) {
            gdAlertify.alert("Debe seleccionar una Categoría");
            return;
        }
        console.log(datosProfesionales.categoria);
        console.log(datosProfesionales.clasificacion);
        if (datosProfesionales.clasificacion == undefined) {
            gdAlertify.alert("Debe seleccionar una Clasificación");
            return;
        }

        if (datosPersonales.fechaNacimiento == '') {
            gdAlertify.alert("Debe seleccionar fecha de nacimiento");
            return;
        }
        if (datosPersonales.fechaIngreso == '') {
            gdAlertify.alert("Debe seleccionar fecha de nacimiento");
            return;
        }

        gdAlertify.confirm({
            title: 'Confirmar auxiliar',
            message: '¿Está seguro de crear el auxiliar?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post("/auxiliar/guardar", {
                        datosPersonales,
                        datosProfesionales,
                        disponibilidadTurnos,
                        selectedTurnos,
                        datosPago
                    });

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        if (onSuccess) {
                            onSuccess();
                        } else if (!id) {
                            resetForm(); // Solo limpia si es nuevo
                        } else {
                            navigate(-1);
                        }
                    } else {
                        gdAlertify.alertError(response.data.message);
                    }
                } catch (error) {
                    gdAlertify.alertError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    const groupedEspecialidades = especialidades.reduce((acc, esp) => {
        const { idCategoria, nombreCategoria, idEspecialidad, nombreEspecialidad } = esp;
        // Si la categoría no existe en el acumulador, la creamos
        if (!acc[idCategoria]) {
            acc[idCategoria] = {
                nombreCategoria,
                especialidades: [],
            };
        }

        // Agregar la especialidad al grupo correspondiente
        acc[idCategoria].especialidades.push({ idEspecialidad, nombreEspecialidad });

        return acc;
    }, {});

    const handleComuna = (selectedOption) => {
        setDatosPersonales({ ...datosPersonales, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleCategorizacion = (selectedOption) => {
        setDatosProfesionales({
            ...datosProfesionales,
            categoria: selectedOption ? selectedOption.value : "" // Actualizamos la categoría correctamente
        });
    };

    const handleClasificacion = (selectedOption) => {
        setDatosProfesionales({ ...datosProfesionales, clasificacion: selectedOption ? selectedOption.value : "" });
    };

    const handleAnticipo = (selectedOption) => {
        setDatosProfesionales({ ...datosProfesionales, anticipo: selectedOption ? selectedOption.value : "" });
    };

    const handleTipoDocumentoChange = (e) => {
        setDatosPersonales({ ...datosPersonales, tipoDocumento: e.target.value ? e.target.value : "" });
        setTipoDocumento(e.target.value);
    };

    useEffect(() => {
        if (datosPago.tipoCuenta === 'propia') {
            setDatosPago(prev => ({
                ...prev,
                rutPago: datosPersonales.rut,
                nombrePago: `${datosPersonales.nombre} ${datosPersonales.primerApellido}`.trim()
            }));
        }
    }, [
        datosPersonales.rut,
        datosPersonales.nombre,
        datosPersonales.primerApellido,
        datosPago.tipoCuenta
    ]);


    return (
        <form onSubmit={handleSubmit} className={idAuxiliar ? "mt-2" : "container mt-5"}>
            <div className="card shadow">
                <div className="card-body">
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Personales</legend>
                        <div className="row">
                            <div>
                                <label>
                                    <input
                                        type="radio"
                                        value="RUT"
                                        checked={tipoDocumento === "RUT"}
                                        onChange={handleTipoDocumentoChange}
                                    /> RUT&nbsp;
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="rutProvisorio"
                                        checked={tipoDocumento === "rutProvisorio"}
                                        onChange={handleTipoDocumentoChange}
                                    /> RUT provisorio&nbsp;
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="Pasaporte"
                                        checked={tipoDocumento === "Pasaporte"}
                                        onChange={handleTipoDocumentoChange}
                                    /> Pasaporte&nbsp;
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="rutExtranjero"
                                        checked={tipoDocumento === "rutExtranjero"}
                                        onChange={handleTipoDocumentoChange}
                                    /> RUT extranjero&nbsp;
                                </label>
                            </div>
                            {[
                                { name: "rut", label: "Nro° documento" },
                                { name: "nombre", label: "Nombres" },
                                { name: "primerApellido", label: "Primer Apellido" },
                                { name: "segundoApellido", label: "Segundo Apellido" },
                                { name: "numeroCelular", label: "Número de Celular" },
                                { name: "estatura", label: "Estatura (cm)" },
                                { name: "nacionalidad", label: "Nacionalidad" },
                                { name: "fechaNacimiento", label: "Fecha de Nacimiento", type: "date" },
                                { name: "mail", label: "Email" },
                                { name: "direccion", label: "Dirección" },
                            ].map((field) => (
                                <div className="col-md-6 mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>
                                    <input
                                        type={field.type || "text"}
                                        className="form-control"
                                        name={field.name}
                                        value={datosPersonales[field.name]}
                                        onChange={(e) => { handleInputChange(e, datosPersonales, setDatosPersonales) }}
                                    />
                                </div>
                            ))}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Situacion migratoria</label>
                                <select
                                    className="form-control"
                                    name="situacionMigratoria"
                                    value={datosPersonales.situacionMigratoria}
                                    onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}
                                >
                                    <option value="">Seleccione</option>
                                    <option value="Chileno">Chileno</option>
                                    <option value="Extranjero en tramite">Extranjero en tramite</option>
                                    <option value="Pendiente">Pendiente</option>
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Comuna</label>
                                <Select
                                    options={comunas}
                                    value={comunas.find(option => option.value == datosPersonales.comuna)} // Compara por 'value' en lugar de 'label'
                                    onChange={handleComuna}
                                    placeholder="Seleccione una comuna"
                                    isClearable
                                />

                            </div>
                            <p><strong>Edad:</strong> {calculateAge(datosPersonales.fechaNacimiento)}</p>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Genero</label>
                                <select
                                    className="form-control"
                                    id="sexo"
                                    name="sexo"
                                    value={datosPersonales.sexo} // Aquí se establece el valor seleccionado
                                    onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}
                                >
                                    <option value="" disabled>Seleccione un género</option>
                                    <option value="1">Masculino</option>
                                    <option value="2">Femenino</option>
                                    <option value="3">Otro</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Fecha ingreso</label>
                                        <input
                                            type='date'
                                            className="form-control"
                                            name='fechaIngreso'
                                            value={datosPersonales.fechaIngreso}
                                            onChange={(e) => { handleInputChange(e, datosPersonales, setDatosPersonales) }}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Fecha retiro</label>
                                        <input
                                            type='date'
                                            className="form-control"
                                            name='fechaRetiro'
                                            value={datosPersonales.fechaRetiro}
                                            onChange={(e) => { handleInputChange(e, datosPersonales, setDatosPersonales) }}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Fecha reintegro</label>
                                        <input
                                            type='date'
                                            className="form-control"
                                            name='fechaReintegro'
                                            value={datosPersonales.fechaReintegro}
                                            onChange={(e) => { handleInputChange(e, datosPersonales, setDatosPersonales) }}
                                        />
                                    </div>
                                </div>
                                {datosPersonales.historialEstadoLaboral?.length > 0 && (
                                    <div className="small text-muted">
                                        {datosPersonales.historialEstadoLaboral.slice(0, 5).map((item) => (
                                            <div key={item.id}>
                                                {item.tipo_evento}: {item.fecha_evento} por {item.usuario_nombre || 'Sistema'}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Presentación Personal</label>
                                <textarea
                                    className="form-control"
                                    name="presentacionPersonal"
                                    rows="2"
                                    value={datosPersonales.presentacionPersonal}
                                    onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones Iniciales</label>
                                <textarea
                                    className="form-control"
                                    name="observacionesPersonales"
                                    rows="2"
                                    value={datosPersonales.observacionesPersonales}
                                    onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Profesionales</legend>
                        <div className="row">
                            {[
                                { name: "titulo", label: "Título o Diploma" },
                                { name: "institucion", label: "Institución" },
                            ].map((field) => (
                                <div className="col-md-6 mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={field.name}
                                        value={datosProfesionales[field.name]}
                                        onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                    />
                                </div>
                            ))}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Especialidades</label>
                                <div className="row">
                                    {Object.keys(groupedEspecialidades).map((categoriaId) => {
                                        const categoria = groupedEspecialidades[categoriaId];
                                        return (
                                            <fieldset className="border p-3 mb-3" key={categoriaId}>
                                                <div className="col-md-12">
                                                    <h5>{categoria.nombreCategoria}</h5>
                                                    <div className="row">
                                                        {categoria.especialidades.map((esp) => (
                                                            <div className="col-md-2" key={esp.idEspecialidad}>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        value={esp.idEspecialidad}
                                                                        checked={datosProfesionales.especialidades.includes(Number(esp.idEspecialidad))}
                                                                        onChange={handleEspecialidadesChange}
                                                                    />
                                                                    <label className="form-check-label">{esp.nombreEspecialidad}</label>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </fieldset>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="col-md-12 mb-3">
                                <label className="form-label">Categoria</label>
                                <Select
                                    options={categorizaciones}  // Aquí deberías tener las categorías ya formateadas
                                    value={categorizaciones.find(option => option.value == datosProfesionales.categoria)} // Aquí buscamos la opción seleccionada
                                    onChange={handleCategorizacion} // Cambiamos la categoría
                                    placeholder="Seleccione una categoría"
                                    isClearable
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones Categoria</label>
                                <textarea
                                    className="form-control"
                                    name="obsCategoria"
                                    rows="2"
                                    value={datosProfesionales.obsCategoria}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Clasificación</label>
                                <Select
                                    options={clasificaciones}
                                    value={clasificaciones.find(option => option.value == datosProfesionales.clasificacion)}
                                    onChange={handleClasificacion}
                                    placeholder="Seleccione una clasificacion"
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Anticipo</label>
                                <Select
                                    options={anticipoOptions}
                                    value={anticipoOptions.find(option => option.value == datosProfesionales.anticipo)}
                                    onChange={handleAnticipo}
                                    placeholder="Seleccione Anticipo"
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Evaluacion</label>
                                <textarea
                                    className="form-control"
                                    name="evaluacion"
                                    rows="2"
                                    value={datosProfesionales.evaluacion}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Experiencia en domicilio</label>
                                <textarea
                                    className="form-control"
                                    name="experienciaDomicilio"
                                    rows="2"
                                    value={datosProfesionales.experienciaDomicilio}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Experiencia Institución Geriatrica</label>
                                <textarea
                                    className="form-control"
                                    name="experienciaGeriatica"
                                    rows="2"
                                    value={datosProfesionales.experienciaGeriatica}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Recomendada por:</label>
                                <textarea
                                    className="form-control"
                                    name="recomendadaPor"
                                    rows="2"
                                    value={datosProfesionales.recomendadaPor}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Disponibilidad de Turnos</legend>
                        <div className="row">
                            {turnos.map((turno) => (
                                <div key={turno.id} className="col-md-3 mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={turno.id}
                                        value={turno.id} // 👈 valor explícito
                                        checked={selectedTurnos.includes(turno.id)} // Verifica si el turno está seleccionado
                                        onChange={handleTurnoChange}
                                    />
                                    <label className="form-check-label" htmlFor={turno.id}>
                                        {turno.nombre}
                                    </label>
                                </div>
                            ))}
                            {/* {[
                                { name: "turno24x24", label: "Turno 24x24" },
                                { name: "turno48x48", label: "Turno 48x48" },
                                { name: "turnoDia", label: "Turno Día" },
                                { name: "turnoNoche", label: "Turno Noche" },
                            ].map((turno) => (
                                <div className="col-md-3 mb-3" key={turno.name}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        name={turno.name}
                                        checked={disponibilidadTurnos[turno.name]}
                                        onChange={(e) => handleInputChange(e, disponibilidadTurnos, setDisponibilidadTurnos)}
                                    />
                                    <label className="form-check-label">{turno.label}</label>
                                </div>
                            ))} */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones Turnos</label>
                                <textarea
                                    className="form-control"
                                    name="obsTurnos"
                                    rows="2"
                                    value={datosProfesionales.obsTurnos}
                                    onChange={(e) =>
                                        handleInputChange(e, datosProfesionales, setDatosProfesionales)
                                    }
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>

                    {/* NUEVO: Fieldset Datos de Pago */}
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos de Pago</legend>
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Tipo de Cuenta</label>
                                <select
                                    className="form-control"
                                    name="tipoCuenta"
                                    value={datosPago.tipoCuenta}
                                    onChange={handleTipoCuentaChange}
                                >
                                    <option value="propia">Cuenta Propia</option>
                                    <option value="tercero">Tercero</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">RUT</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="rutPago"
                                    value={datosPago.rutPago}
                                    onChange={handleDatosPagoChange}
                                    disabled={datosPago.tipoCuenta === 'propia'}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Nombre</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="nombrePago"
                                    value={datosPago.nombrePago}
                                    onChange={handleDatosPagoChange}
                                    disabled={datosPago.tipoCuenta === 'propia'}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-label">Banco</label>
                                <select
                                    className="form-control"
                                    name="banco"
                                    value={datosPago.banco}
                                    onChange={handleDatosPagoChange}
                                >
                                    <option value="">Seleccione un banco</option>
                                    <option value="Banco de Chile">Banco de Chile</option>
                                    <option value="Banco Internacional">Banco Internacional</option>
                                    <option value="Scotiabank">Scotiabank</option>
                                    <option value="Banco de Crédito e Inversiones (BCI)">Banco de Crédito e Inversiones (BCI)</option>
                                    <option value="Banco BICE">Banco BICE</option>
                                    <option value="HSBC Bank">HSBC Bank</option>
                                    <option value="Banco Santander">Banco Santander</option>
                                    <option value="Banco Itaú">Banco Itaú</option>
                                    <option value="Banco Security">Banco Security</option>
                                    <option value="Banco Falabella">Banco Falabella</option>
                                    <option value="Banco Ripley">Banco Ripley</option>
                                    <option value="Banco Consorcio">Banco Consorcio</option>
                                    <option value="Banco Estado">Banco Estado</option>
                                    <option value="Banco BTG Pactual">Banco BTG Pactual</option>
                                    <option value="Tenpo">Tenpo</option>
                                    <option value="Mach">Mach</option>
                                    <option value="Chek">Chek</option>
                                    <option value="Mercado Pago">Mercado Pago</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Tipo de Cuenta Bancaria</label>
                                <select
                                    className="form-control"
                                    name="tipoCuentaBancaria"
                                    value={datosPago.tipoCuentaBancaria}
                                    onChange={handleDatosPagoChange}
                                >
                                    <option value="">Seleccione tipo de cuenta</option>
                                    <option value="Cuenta Corriente">Cuenta Corriente</option>
                                    <option value="Cuenta Vista">Cuenta Vista</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Número de Cuenta</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="numeroCuenta"
                                    value={datosPago.numeroCuenta}
                                    onChange={handleDatosPagoChange}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label">Datos SII</label>
                                <textarea
                                    className="form-control"
                                    name="datosSII"
                                    rows="2"
                                    value={datosPago.datosSII}
                                    onChange={handleDatosPagoChange}
                                />
                            </div>
                        </div>

                    </fieldset>

                    <div className="d-grid">
                        <button className="btn btn-primary" type="submit">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default IngresoAuxiliar;
